import { useAtom, atom } from 'jotai';
import {
    Drawer,
    DrawerContent,
    DrawerDescription,
    DrawerHeader,
    DrawerTitle,
} from '@rocco/components/drawer';
import { ManageCollaboratorForm } from './ManageCollaboratorForm';

export const uiStateAtomManageCollabratorModalIsOpened = atom(false);

export const ManageCollabratorModal = () => {
    const [isOpen, setIsOpen] = useAtom(
        uiStateAtomManageCollabratorModalIsOpened
    );

    return (
        <Drawer open={isOpen} onOpenChange={setIsOpen} direction="right">
            <DrawerContent
                className="data-[vaul-drawer-direction=right]:sm:max-w-[40rem]"
                variant="default"
                overlayVariant="dark"
                noHandle={true}
                scrollable={true}
            >
                <DrawerHeader className="hidden" aria-hidden>
                    {/* Supress missing title/description console warning */}
                    <DrawerTitle className="hidden" aria-hidden>
                        Our Project Team
                    </DrawerTitle>
                    <DrawerDescription className="hidden" aria-hidden />
                </DrawerHeader>
                <div className="px-6 py-4 md:px-8 md:py-8">
                    <ManageCollaboratorForm />
                </div>
            </DrawerContent>
        </Drawer>
    );
};
